module.exports = {
    TO_BET: 'TO_BET',
    WAITING_BET_ASKED: 'WAITING_BET_ASKED',
    WAITING_BETS: 'WAITING_BETS',
    TO_ASK: 'TO_ASK',
    WAITING_ASKED: 'WAITING_ASKED',
    WAITING_ANSWERS: 'WAITING_ANSWERS',
    ANSWERED: 'ANSWERED',
    ASKED: 'ASKED',
    COMPLETED: 'COMPLETED'
}


// WEBPACK FOOTER //
// ./src/reducers/questions/status.js